import plansSaga from './plans.saga';

export default plansSaga;
